'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var interfaceDatastore = require('interface-datastore');

var datastoreCore = require('datastore-core');

var utils = require('./utils.js');

var equals = require('uint8arrays/equals');

var errcode = require('err-code');

var debug = require('debug');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errcode__default = /*#__PURE__*/_interopDefaultLegacy(errcode);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = Object.assign(debug__default['default']('datastore-pubsub:publisher'), {
  error: debug__default['default']('datastore-pubsub:publisher:error')
});

var PubsubDatastore = /*#__PURE__*/function (_datastoreCore$BaseDa) {
  _inherits(PubsubDatastore, _datastoreCore$BaseDa);

  var _super = _createSuper(PubsubDatastore);

  function PubsubDatastore(pubsub, datastore, peerId, validator, subscriptionKeyFn) {
    var _this;

    _classCallCheck(this, PubsubDatastore);

    _this = _super.call(this);

    if (!validator) {
      throw errcode__default['default'](new TypeError('missing validator'), 'ERR_INVALID_PARAMETERS');
    }

    if (typeof validator.validate !== 'function') {
      throw errcode__default['default'](new TypeError('missing validate function'), 'ERR_INVALID_PARAMETERS');
    }

    if (typeof validator.select !== 'function') {
      throw errcode__default['default'](new TypeError('missing select function'), 'ERR_INVALID_PARAMETERS');
    }

    if (subscriptionKeyFn && typeof subscriptionKeyFn !== 'function') {
      throw errcode__default['default'](new TypeError('invalid subscriptionKeyFn received'), 'ERR_INVALID_PARAMETERS');
    }

    _this._pubsub = pubsub;
    _this._datastore = datastore;
    _this._peerId = peerId;
    _this._validator = validator;
    _this._handleSubscriptionKeyFn = subscriptionKeyFn;
    _this._onMessage = _this._onMessage.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PubsubDatastore, [{
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, val) {
        var errMsg, _errMsg, stringifiedTopic;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (key instanceof Uint8Array) {
                  _context.next = 4;
                  break;
                }

                errMsg = 'datastore key does not have a valid format';
                log.error(errMsg);
                throw errcode__default['default'](new Error(errMsg), 'ERR_INVALID_DATASTORE_KEY');

              case 4:
                if (val instanceof Uint8Array) {
                  _context.next = 8;
                  break;
                }

                _errMsg = 'received value is not a Uint8Array';
                log.error(_errMsg);
                throw errcode__default['default'](new Error(_errMsg), 'ERR_INVALID_VALUE_RECEIVED');

              case 8:
                stringifiedTopic = utils.keyToTopic(key);
                log("publish value for topic ".concat(stringifiedTopic));
                _context.next = 12;
                return this._pubsub.publish(stringifiedTopic, val);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function put(_x, _x2) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var errMsg, stringifiedTopic, subscriptions, _errMsg2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (key instanceof Uint8Array) {
                  _context2.next = 4;
                  break;
                }

                errMsg = 'datastore key does not have a valid format';
                log.error(errMsg);
                throw errcode__default['default'](new Error(errMsg), 'ERR_INVALID_DATASTORE_KEY');

              case 4:
                stringifiedTopic = utils.keyToTopic(key);
                _context2.next = 7;
                return this._pubsub.getTopics();

              case 7:
                subscriptions = _context2.sent;

                if (!(subscriptions && Array.isArray(subscriptions) && subscriptions.indexOf(stringifiedTopic) > -1)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", this._getLocal(key));

              case 10:
                _context2.prev = 10;

                this._pubsub.on(stringifiedTopic, this._onMessage);

                _context2.next = 14;
                return this._pubsub.subscribe(stringifiedTopic);

              case 14:
                _context2.next = 21;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](10);
                _errMsg2 = "cannot subscribe topic ".concat(stringifiedTopic);
                log.error(_errMsg2);
                throw errcode__default['default'](new Error(_errMsg2), 'ERR_SUBSCRIBING_TOPIC');

              case 21:
                log("subscribed values for key ".concat(stringifiedTopic));
                return _context2.abrupt("return", this._getLocal(key));

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[10, 16]]);
      }));

      function get(_x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "unsubscribe",
    value: function unsubscribe(key) {
      var stringifiedTopic = utils.keyToTopic(key);

      this._pubsub.removeListener(stringifiedTopic, this._onMessage);

      return this._pubsub.unsubscribe(stringifiedTopic);
    }
  }, {
    key: "_getLocal",
    value: function () {
      var _getLocal2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        var routingKey, dsVal, _errMsg3, errMsg, _errMsg4;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                routingKey = new interfaceDatastore.Key('/' + utils.encodeBase32(key), false);
                _context3.prev = 1;
                _context3.next = 4;
                return this._datastore.get(routingKey);

              case 4:
                dsVal = _context3.sent;
                _context3.next = 16;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](1);

                if (!(_context3.t0.code !== 'ERR_NOT_FOUND')) {
                  _context3.next = 13;
                  break;
                }

                _errMsg3 = "unexpected error getting the ipns record for ".concat(routingKey.toString());
                log.error(_errMsg3);
                throw errcode__default['default'](new Error(_errMsg3), 'ERR_UNEXPECTED_ERROR_GETTING_RECORD');

              case 13:
                errMsg = "local record requested was not found for ".concat(routingKey.toString());
                log.error(errMsg);
                throw errcode__default['default'](new Error(errMsg), 'ERR_NOT_FOUND');

              case 16:
                if (dsVal instanceof Uint8Array) {
                  _context3.next = 20;
                  break;
                }

                _errMsg4 = 'found record that we couldn\'t convert to a value';
                log.error(_errMsg4);
                throw errcode__default['default'](new Error(_errMsg4), 'ERR_INVALID_RECORD_RECEIVED');

              case 20:
                return _context3.abrupt("return", dsVal);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 7]]);
      }));

      function _getLocal(_x4) {
        return _getLocal2.apply(this, arguments);
      }

      return _getLocal;
    }()
  }, {
    key: "_onMessage",
    value: function () {
      var _onMessage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(msg) {
        var data, from, topicIDs, key, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = msg.data, from = msg.from, topicIDs = msg.topicIDs;
                _context4.prev = 1;
                key = utils.topicToKey(topicIDs[0]);
                _context4.next = 9;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4["catch"](1);
                log.error(_context4.t0);
                return _context4.abrupt("return");

              case 9:
                log("message received for topic ".concat(topicIDs[0]));

                if (!(from === this._peerId.toB58String())) {
                  _context4.next = 13;
                  break;
                }

                log('message discarded as it is from the same peer');
                return _context4.abrupt("return");

              case 13:
                if (!this._handleSubscriptionKeyFn) {
                  _context4.next = 25;
                  break;
                }

                _context4.prev = 14;
                _context4.next = 17;
                return this._handleSubscriptionKeyFn(key);

              case 17:
                res = _context4.sent;
                _context4.next = 24;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t1 = _context4["catch"](14);
                log.error('message discarded by the subscriptionKeyFn');
                return _context4.abrupt("return");

              case 24:
                key = res;

              case 25:
                _context4.prev = 25;
                _context4.next = 28;
                return this._storeIfSubscriptionIsBetter(key, data);

              case 28:
                _context4.next = 33;
                break;

              case 30:
                _context4.prev = 30;
                _context4.t2 = _context4["catch"](25);
                log.error(_context4.t2);

              case 33:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 5], [14, 20], [25, 30]]);
      }));

      function _onMessage(_x5) {
        return _onMessage2.apply(this, arguments);
      }

      return _onMessage;
    }()
  }, {
    key: "_storeIfSubscriptionIsBetter",
    value: function () {
      var _storeIfSubscriptionIsBetter2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(key, data) {
        var isBetter;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                isBetter = false;
                _context5.prev = 1;
                _context5.next = 4;
                return this._isBetter(key, data);

              case 4:
                isBetter = _context5.sent;
                _context5.next = 11;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](1);

                if (!(_context5.t0.code !== 'ERR_NOT_VALID_RECORD')) {
                  _context5.next = 11;
                  break;
                }

                throw _context5.t0;

              case 11:
                if (!isBetter) {
                  _context5.next = 14;
                  break;
                }

                _context5.next = 14;
                return this._storeRecord(key, data);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 7]]);
      }));

      function _storeIfSubscriptionIsBetter(_x6, _x7) {
        return _storeIfSubscriptionIsBetter2.apply(this, arguments);
      }

      return _storeIfSubscriptionIsBetter;
    }()
  }, {
    key: "_validateRecord",
    value: function () {
      var _validateRecord2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(value, peerId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this._validator.validate(value, peerId));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _validateRecord(_x8, _x9) {
        return _validateRecord2.apply(this, arguments);
      }

      return _validateRecord;
    }()
  }, {
    key: "_selectRecord",
    value: function () {
      var _selectRecord2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(key, records) {
        var res;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._validator.select(key, records);

              case 2:
                res = _context7.sent;
                return _context7.abrupt("return", res === 0);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _selectRecord(_x10, _x11) {
        return _selectRecord2.apply(this, arguments);
      }

      return _selectRecord;
    }()
  }, {
    key: "_isBetter",
    value: function () {
      var _isBetter2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(key, val) {
        var errMsg, dsKey, currentRecord;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return this._validateRecord(val, key);

              case 3:
                _context8.next = 10;
                break;

              case 5:
                _context8.prev = 5;
                _context8.t0 = _context8["catch"](0);
                errMsg = 'record received through pubsub is not valid';
                log.error(errMsg);
                throw errcode__default['default'](new Error(errMsg), 'ERR_NOT_VALID_RECORD');

              case 10:
                dsKey = new interfaceDatastore.Key(key);
                _context8.prev = 11;
                _context8.next = 14;
                return this._getLocal(dsKey.uint8Array());

              case 14:
                currentRecord = _context8.sent;
                _context8.next = 20;
                break;

              case 17:
                _context8.prev = 17;
                _context8.t1 = _context8["catch"](11);
                return _context8.abrupt("return", true);

              case 20:
                if (!equals.equals(currentRecord, val)) {
                  _context8.next = 22;
                  break;
                }

                return _context8.abrupt("return", false);

              case 22:
                return _context8.abrupt("return", this._selectRecord(key, [currentRecord, val]));

              case 23:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 5], [11, 17]]);
      }));

      function _isBetter(_x12, _x13) {
        return _isBetter2.apply(this, arguments);
      }

      return _isBetter;
    }()
  }, {
    key: "_storeRecord",
    value: function () {
      var _storeRecord2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(key, data) {
        var routingKey;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                routingKey = new interfaceDatastore.Key('/' + utils.encodeBase32(key), false);
                _context9.next = 3;
                return this._datastore.put(routingKey, data);

              case 3:
                log("record for ".concat(utils.keyToTopic(key), " was stored in the datastore"));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function _storeRecord(_x14, _x15) {
        return _storeRecord2.apply(this, arguments);
      }

      return _storeRecord;
    }()
  }]);

  return PubsubDatastore;
}(datastoreCore.BaseDatastore);

exports.PubsubDatastore = PubsubDatastore;